import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PageTitleService } from '@core/page-title/services/page-title.service';
import { ApplicationVersionFacade } from '@core/application-version/facades/application-version.facade';
import { ResetStateFacade } from '@core/store/facades/reset-state.facade';
import { MobileVersionManagerService } from '@layout/mobile-stub/services/mobile-version-manager.service';
import { BrowserEventsService } from '@layout/session-timeout/services/browser-events.service';
import { UserActivityService } from '@layout/session-timeout/services/user-activity.service';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { MobileStubComponent } from '@layout/mobile-stub/components/mobile-stub/mobile-stub.component';
import { WalkMeInitFacade } from '@core/walk-me/facades/walk-me-init.facade';
import { MonitoringFacade } from '@core/monitoring/facades/monitoring.facade';
import { AdaChatButtonComponent } from '@layout/ada-chat-button/components/ada-chat-button/ada-chat-button.component';
import { ModuleTrialRequestsFacade } from '@core/module-trial-requests/facades/module-trial-requests.facade';
import { PaymentManagementActiveFacade } from '@layout/payment-management-active/facades/payment-management-active.facade';

@Component({
  selector: 'itc-app-root',
  templateUrl: 'app.component.html',
  styleUrl: 'app.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [RouterOutlet, MobileStubComponent, AsyncPipe, AdaChatButtonComponent],
})
export class AppComponent {
  private readonly browserEventsService = inject(BrowserEventsService);
  private readonly userActivityService = inject(UserActivityService);
  private readonly pageTitleService = inject(PageTitleService);
  private readonly mobileVersionManagerService = inject(MobileVersionManagerService);
  private readonly walkMeInitFacade = inject(WalkMeInitFacade);
  private readonly applicationVersionFacade = inject(ApplicationVersionFacade);
  private readonly resetStateFacade = inject(ResetStateFacade);
  private readonly authorizationService = inject(AuthorizationService);
  private readonly userInfoFacade = inject(UserInfoFacade);
  private readonly monitoringFacade = inject(MonitoringFacade);
  private readonly moduleTrialRequestsFacade = inject(ModuleTrialRequestsFacade);
  private readonly paymentManagementActiveFacade = inject(PaymentManagementActiveFacade);

  isMobileVersionDisabled$ = this.mobileVersionManagerService.isMobileVersionDisabled();
}
